module.exports = __webpack_public_path__ + "static/media/relay.cbb29ddb.png";